

const TRANSLATIONS_FR_FR = {
    "email_otp.back":"Retour",
    "email_otp.enter_email_text":"Saisissez votre adresse e-mail ci-dessous pour recevoir un code de vérification unique.",
    "email_otp.send_verification_link":"Envoyer le code de vérification",
    "email_otp.resend_otp_with_timer":"Renvoyer le code dans",
    "email_otp.text":"Un code de vérification à six chiffres a été envoyé à l’adresse [email]. Veuillez saisir le code ci-dessous",
    "email_otp.verify":"Vérifier",
    "reset_password.set_password":"Définissez votre mot de passe",
    "sign_in.or":"ou",
    "sign_in.continue_with":"Ou continuez avec",
    "sign_in.continue_with_email":"Ou continuez avec une adresse e-mail",
    "sign_in.create_without_password":"Créez un compte sans mot de passe",
    "sign_in.create_with_otp":"Créez un compte grâce à un code à usage unique",
    "sign_in.login_with_otp":"Connectez-vous grâce à un code à usage unique",
    "sign_in.login_without_password":"Connectez-vous sans mot de passe",
    "sign_in.tooltip_text":"Vous recevrez un code de vérification unique temporaire par e-mail pour accéder à votre compte.",
    "sign_up.tooltip_text":"Vous recevrez un code de vérification unique temporaire par e-mail pour créer un compte.",
    "sign_in.password_updated":"Votre mot de passe a été mis à jour.",
    "sign_up.create_an_account":"Créez un compte",
    "email_otp.resend_otp":"Renvoyer le code",
    "sign_up.email_address":"Adresse email",
    "sign_up.password":"Mot de passe",
    "sign_in.create_account" : "Créer un compte",
    "sign_in.title": "Se Connecter",
    "sign_in.forgot_password" : "Mot de passe oublié ?",
    "reset_password.resend_email": "Me renvoyer l'e-mail",
    "reset_password.sent_title": "Un e-mail de confirmation a été envoyé !",
    "reset_password.rcvResetLink": "Entrez votre adresse e-mail ci-dessous et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "reset_password.submit": "Soumettre",
    "reset_password.back_to_login": "Retournez à la page de connexion",
    "reset_password.create_new_password": "Créez un nouveau mot de passe pour vous connecter à votre compte.",
    "forgot_password.emailSent": "Si l'adresse e-mail saisie [] est associée à un compte, vous recevrez un lien par e-mail pour réinitialiser votre mot de passe. Vous n'avez pas encore reçu l'e-mail ? Me renvoyer un nouvel e-mail.",
    "gdpr.continue": "Continuer",
    "validation.password_validation_heading": "Le mot de passe doit inclure :",
    "validation.password_length_ui": "8 caractères minimum",
    "validation.password_upper_case_ui": "Un caractère majuscule",
    "validation.password_lower_case_ui": "Un caractère minuscule",
    "validation.password_number_ui": "Un nombre",
    "validation.password_symbol_ui": "Un caractère spécial",
    "verify_otp.customer_service_center_link": "s/service-client",
    "activate_user.verification_successful.message": "Félicitations ! Votre compte a été activé.",
    "activate_user.already_verified.message" : "Nous sommes ravis de vous revoir ! Votre compte a déjà été vérifié.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Veuillez remplir tous les champs obligatoires pour continuer.",
    "sign_in.invalid_email_error": "Veuillez saisir votre adresse e-mail au format requis. Par exemple : nom@domaine.com",
    "sign_in.invalid_credentials_error": "Votre identifiant ou votre mot de passe n’est pas valide. Veuillez réessayer.",
    "sign_in.generic_error": "Une erreur est survenue. Veuillez réessayer.",
    "sign_in.account_unverified_error": "Votre compte n’est pas encore activé. Veuillez vérifier dans votre boîte de réception si vous avez reçu le lien d’activation, ou cliquez sur « Mot de passe oublié ? » pour réinitialiser l’accès à votre compte.",
    "sign_in.max_attempt_error": "Nombre maximum de tentatives atteint. Veuillez réessayer plus tard.",
    "sign_in.social_signin_error": "La connexion via les réseaux sociaux (Google/Facebook/Apple) a échoué. Veuillez réessayer ou utiliser une autre méthode de connexion.",
    "sign_in.social_signin_email_not_present_error": "La connexion a échoué. Veuillez réessayer ou utiliser une autre méthode de connexion.",
    "sign_in.guest_user_signin_error": "Il semble qu’un compte soit déjà associé à cette adresse e-mail. Cliquez sur « Mot de passe oublié » pour réinitialiser l’accès à votre compte.",

    "sign_up.mandatory_field_error": "Veuillez remplir tous les champs obligatoires pour continuer.",
    "sign_up.invalid_email_error": "Veuillez saisir une adresse e-mail valide. Par exemple : nom@domaine.com",
    "sign_up.password_length_error": "Le mot de passe doit contenir au moins 8 caractères.",
    "sign_up.email_already_exist_error": "Cette adresse e-mail existe déjà. Veuillez utiliser une autre adresse.",
    "sign_up.generic_error": "Une erreur est survenue. Veuillez réessayer.",
    "sign_up.password_policy_error": "Le mot de passe doit inclure : un chiffre, un caractère spécial [!#$%&'*+-/=?^_`{|}~.@], une lettre majuscule et une minuscule.",
    "sign_up.common_password_error": "Le mot de passe ne peut pas être identique à votre adresse e-mail.",

    "forgot_password.mandatory_field_error": "Veuillez remplir tous les champs obligatoires pour continuer.",
    "forgot_password.invalid_email_error": "Veuillez saisir votre adresse e-mail au format requis. Par exemple : nom@domaine.com",
    "forgot_password.generic_error": "Une erreur est survenue. Veuillez réessayer.",

    "reset_password.mandatory_field_error": "Veuillez remplir tous les champs obligatoires pour continuer.",
    "reset_password.password_history_error": "Le mot de passe doit être différent des cinq précédents.",
    "reset_password.password_length_error": "Le mot de passe doit contenir au moins 8 caractères.",
    "reset_password.password_policy_error": "Le mot de passe doit inclure : un chiffre, un caractère spécial [!#$%&'*+-/=?^_`{|}~.@], une lettre majuscule et une minuscule.",
    "reset_password.common_password_error": "Le mot de passe ne peut pas être identique à votre adresse e-mail.",
    "reset_password.generic_error": "Une erreur est survenue. Veuillez réessayer.",

    "email_otp.email_required_error": "Veuillez saisir votre e-mail pour continuer.",
    "email_otp.invalid_email_error": "Veuillez saisir une adresse e-mail valide. Par exemple : nom@domaine.com",
    "email_otp.generic_error": "Une erreur est survenue. Veuillez réessayer plus tard.",
    "email_otp.invalid_otp_error": "Le code OTP/de vérification que vous avez saisi est invalide. Veuillez réessayer.",
    "email_otp.resend_otp_error": "Impossible de renvoyer le code OTP. Veuillez réessayer plus tard.",
    "email_otp.verify_otp_error": "Une erreur est survenue. Veuillez réessayer la vérification OTP plus tard.",
    "email_otp.verify_otp_limit_exceed_error": "Le code OTP saisi est invalide. Cliquez sur « Renvoyer le code OTP » pour en obtenir un nouveau.",
    "email_otp.max_attempt_reached_error": "Nombre maximum de tentatives atteint. Veuillez réessayer plus tard.",
    "email_otp.brute_force_error_part_1": "Votre compte a été temporairement verrouillé en raison de plusieurs tentatives de connexion infructueuses. Veuillez réessayer plus tard ou ",
    "email_otp.brute_force_error_part_2": "contacter notre Centre d’aide",
    "email_otp.brute_force_error_part_3": ".",
    "form.gdprconsent": "En vous connectant, vous acceptez nos",
    "form.termsCondition": "conditions générales",

    //Page Titles
    "sign_in.page_title": "Se connecter | Pens.com",
    "sign_up.page_title": "S'inscrire | Pens.com",
    "forgot-password.page_title": "Mot de Passe Oublié | Pens.com",
    "reset-password.page_title": "Réinitialiser le Mot de Passe | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_FR_FR;